import { quickNames } from '@/constants/type';
import { parse } from 'querystring';

export function getNowTime() {
  let dateTime
  let yy = new Date().getFullYear()
  let mm = new Date().getMonth() + 1
  let dd = new Date().getDate()
  let hh = new Date().getHours()
  let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
    :
    new Date().getMinutes()
  let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
    :
    new Date().getSeconds()
  dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
  return dateTime
}

export function getCookie(key: string): string {
  const reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
  let arr: any = null;
  if (document.cookie.match(reg)) {
    arr = document.cookie.match(reg);
    return decodeURIComponent(arr[2]);
  }
  return "irpW4HPUO2ESEWi6LG0trlGeBNJr3EDqryuBJuBs5V0C4lb32lVmhf5Z9HNHOb3SuAt0tv9zqAbk50WGP3tsWClEudQ16KmW6miet4BnZ4fLvPbL4SBM0uYNquG2TDuuB2k2cxn/qnHxFM8uBRcmx125tD/kkbggDCMKeyYM62giSNMtjrcwmQ==";
};
/**
   * @description 生成样式表
   */
export function addCSS(cssText: string, id: string) {
  let style: any = document.createElement('style'),  //创建一个style元素
    head = document.head || document.getElementsByTagName('head')[0]; //获取head元素
  style.type = 'text/css'; //这里必须显示设置style元素的type属性为text/css，否则在ie中不起作用
  style.id = id || String(Math.random())
  // 清除相同id的style
  const styleEl = document.getElementById(id)
  if (styleEl) {
    document.head.removeChild(styleEl)
  }
  if (style.styleSheet) { //IE
    let func = function () {
      try { //防止IE中stylesheet数量超过限制而发生错误
        style.styleSheet.cssText = cssText;
      } catch (e) {

      }
    }
    //如果当前styleSheet还不能用，则放到异步中则行
    if (style.styleSheet.disabled) {
      setTimeout(func, 10);
    } else {
      func();
    }
  } else { //w3c
    //w3c浏览器中只要创建文本节点插入到style元素中就行了
    let textNode = document.createTextNode(cssText);
    style.appendChild(textNode);
  }
  head.appendChild(style); //把创建的style元素插入到head中    
}

export const getPageQuery = () => {
  const { href } = window.location;
  const qsIndex = href.indexOf('?');
  const sharpIndex = href.indexOf('#');
  if (qsIndex !== -1) {
    if (qsIndex > sharpIndex) {
      return parse(href.split('?')[1]);
    }

    return parse(href.slice(qsIndex + 1, sharpIndex));
  }
  return {};
};

/**
  * @description 去重
  */
export function unique(arr: any[], val: string | number) {
  const res = new Map()
  return arr.filter((item: { [x: string]: any; }) => !res.has(item[val]) && res.set(item[val], 1))
}
/**
* @description 创建鼠标图片
*/
export const createCursor = (rootId: string) => {
  let img = document.createElement('img')
  img.style.position = 'fixed'
  img.id = 'dragImg';
  img.style.width = '80px';
  img.style.height = '60px';
  img.style.opacity = '0.4';
  img.style.display = 'none';
  img.style.objectFit = 'contain';
  if (!document.getElementById('dragImg')) {
    (document.getElementById(rootId) as any)?.appendChild(img)
  }
}
/**
* @description 销毁鼠标图片
*/
export const destoryCursor = () => {
  let img = document.getElementById('dragImg') as HTMLImageElement
  if (img) {
    img.src = ''
    img.style.display = 'none'
  }
}
export function translateJSONparse(key: string) {
  return JSON.parse(sessionStorage.getItem(key) || '""')
}
// export const debounce = <F extends ((...args: any[]) => any)>(
//   func: F,
//   delay: number
// ) => {
//   let timer: ReturnType<typeof setTimeout>;
//   return (...args: Parameters<F>) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => func.apply(this, args), delay);
//   };
// };

export function removeQueryParameter(key: string, url = window.location.href): string {
  const parsedUrl = new URL(url);
  const searchParams = parsedUrl.searchParams;

  searchParams.delete(key);

  return parsedUrl.toString();
}
export function updateQueryParameter(key: string, value: string, url = window.location.href): string {
  try {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;

    // 更新参数值
    searchParams.set(key, value);

    return parsedUrl.toString();
  } catch (error) {
    console.error('Invalid URL:', error);
    return url; // 返回原始 URL
  }
}
export function changeURL(key: string, value?: string, url = window.location.href): string {
  let modifiedUrl = url;

  if (key && value) {
    modifiedUrl = updateQueryParameter(key, value, url);
  } else if (key) {
    modifiedUrl = removeQueryParameter(key, url);
  }

  history.pushState({}, '', modifiedUrl);
  return modifiedUrl; // 返回修改后的 URL
}
export const debounce = (callback: { (): void; apply?: any; }, delay: number | undefined) => {
  let timeoutId: string | number | NodeJS.Timeout | null | undefined = null;
  return (...args: any) => {
    clearTimeout(timeoutId as NodeJS.Timeout);
    timeoutId = setTimeout(() => {
      callback.apply(null, args);
    }, delay);
    if (!timeoutId) {
      callback.apply(null, args); // 立即执行第一次
    }
  };
};
export function arraysAreEqual(arr1: any[], arr2: any[]): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (Array.isArray(arr1[i]) && Array.isArray(arr2[i])) {
      if (!arraysAreEqual(arr1[i], arr2[i])) {
        return false;
      }
    } else if (typeof arr1[i] === 'object' && typeof arr2[i] === 'object') {
      if (JSON.stringify(arr1[i]) !== JSON.stringify(arr2[i])) {
        return false;
      }
    } else if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
}
export function replaceURLParam(paramKey: string, paramValue: string) {
  const currentUrl = window.location.href;
  let updatedUrl;

  if (currentUrl.includes(`${paramKey}=`)) {
    updatedUrl = currentUrl.replace(
      new RegExp(`${paramKey}=[^&]*`),
      `${paramKey}=${paramValue}`
    );
  } else {
    updatedUrl = `${currentUrl}${currentUrl.includes('?') ? '&' : '?'
      }${paramKey}=${paramValue}`;
  }

  window.history.pushState({ path: updatedUrl }, '', updatedUrl);

}
export function getValueFromSearchParams(key: string): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}
// switchToCombination()
/**
* @description 定位到家具组合
*/
export function switchToCombination() {
  const combination = window.location.href.indexOf('combination') > -1
  if (combination) {
    sessionStorage.setItem('use-session-storage-state-gobal-active', '100041')
    sessionStorage.setItem('use-session-storage-state-session-sourceTag', '0')
    sessionStorage.setItem('use-session-storage-state-sub-menu', '154279')
    sessionStorage.setItem('use-session-storage-state-styleis', '{}')
  }
}
/**
* @description 生成唯一id
*/
export function generateUniqueId() {
  return `div-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
}


/**
* @description 是否在3d内嵌页中
*/
export const checkIsIn3D = () => {
  try {
    // 只是在3d模型的时候才会有这个参数
    return window.self !== window.top
    // return true
  } catch (e) {
    return true;
  }
}
export const isIn3D = checkIsIn3D()
/**
  * @description  返回匹配的值
  */
function getMatchingValue(inputString: string): string {
  for (const [key, value] of Object.entries(quickNames)) {
    if (inputString.includes(key)) {
      return value;
    }
  }
  return '';
}
export function checkScreenResolution(): { is2k: boolean; is4k: boolean } {
  const width = window.screen.width;
  const height = window.screen.height;


  const is2k = width > 2048 || height > 1080; // 大于2K
  const is4k = width > 3840 || height > 2160; // 大于4K
  return { is2k, is4k };
}

export const calcTitle = (categoryId: string, menuNames: { [x: string]: string; }) => {
  let title = menuNames?.[categoryId as keyof typeof menuNames] || ''
  if (!title) {
    const result = getMatchingValue(location.pathname);
    title = result
  }
}
export function scrollToElementById(id: string) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView();
  }
}

export function formatNumber(num: number): string {
  if (num > 10000) {
    const formattedNum = (num / 10000).toFixed(1); // 保留一位小数
    return `${formattedNum}万`;
  }
  return num.toString(); // 如果不超过一万，直接返回数字的字符串形式
}
export function supportsWhere() {
  const style = document.createElement('style');
  style.textContent = ':where(div) { color: red; }';
  document.head.appendChild(style);

  const testDiv = document.createElement('div');
  testDiv.className = 'test';
  document.body.appendChild(testDiv);

  const computedStyle = window.getComputedStyle(testDiv).color;

  // 清理
  document.head.removeChild(style);
  document.body.removeChild(testDiv);

  return computedStyle === 'rgb(255, 0, 0)'; // 检查颜色是否为红色
}

export function notifyLoadComplete(callback: () => void) {
  let hasBeenCalled = false;

  return function () {
    if (!hasBeenCalled) {
      hasBeenCalled = true;
      callback?.()
    }
  };
}
/**
  * @description 处理参数
  */
export function modifyUrl(url: string, key: string | string[]): string {
  const urlObj = new URL(url);

  // 将 key 转换为数组，以便统一处理
  const keys = Array.isArray(key) ? key : [key];

  // 遍历 keys 数组，删除每个参数
  keys.forEach(k => {
      urlObj.searchParams.delete(k);
  });

  return urlObj.toString();
}
